/** @jsxImportSource theme-ui */
import { Container, Box, Flex } from 'theme-ui';
import { useNavigate } from 'react-router-dom';
import Tickets from '@/containers/tickets/Tickets';
import Button from '@/components/Button';

const TicketsPage = () => {
    const navigate = useNavigate();
    return (
        <Container>
            <Flex sx={{ flexDirection: 'column', gap: 2 }}>
                <Flex sx={{ justifyContent: 'flex-end' }}>
                    <Button onClick={() => navigate('/tickets/new')}>Add ticket</Button>
                </Flex>
                <Box
                    sx={{
                        borderRadius: 'sm',
                        backgroundColor: 'background',
                        padding: 2,
                    }}
                >
                    <Tickets />
                </Box>
            </Flex>
        </Container>
    );
};

export default TicketsPage;
